var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DarkModeSwitcher'),_c('MobileMenu'),_c('div',{staticClass:"flex"},[_c('Navigation'),_c('Content')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }